import { render, staticRenderFns } from "./user-type-add.vue?vue&type=template&id=2b05cbb4"
import script from "./user-type-add.vue?vue&type=script&lang=js"
export * from "./user-type-add.vue?vue&type=script&lang=js"
import style0 from "./user-type-add.vue?vue&type=style&index=0&id=2b05cbb4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports